import axios from 'axios';
import React from "react";
import imageOverlay from "../img/earth.jpg";

class Contact extends React.Component {
  constructor(props) {
    super();
    this.state = {
      formData: {
        name: '',
        email: '',
        subject: '',
        message: '',
      },
      sending: false,
      validation: {
        show: false,
        status: '',
        info: '',
      },
    };
    this.baseState = this.state;

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      }
    }));
  }

  onSubmit(event) {
    event.preventDefault();
    if (this.state.formData.name === '' || this.state.formData.email === '' || this.state.formData.subject === '' || this.state.formData.message === '') {
      this.setState(prevState => ({
        validation: {
          ...prevState.validation,
          show: true,
          status: 'error',
          info: 'Please complete all field !'
        }
      }));
    } else {
      this.setState({ sending: true });
      const data = { ...this.state.formData };
      console.log(data);
      axios.post(`https://novvapps.com/novvapps_api/index.php`, data)
        .then(res => {
          this.setState(this.baseState);
          this.setState(prevState => ({
            validation: {
              ...prevState.validation,
              show: true,
              status: 'success',
            }
          }));
        })
        .catch(err => {
          this.setState(prevState => ({
            validation: {
              ...prevState.validation,
              show: true,
              status: 'error',
              info: err,
            }
          }));
        });
    }

  }

  render() {
    return (
      <section
        className="paralax-mf footer-paralax bg-image sect-mt4 route"
        style={{ backgroundImage: "url(" + imageOverlay + ")" }}
      >
        <div className="overlay-mf"></div>
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="contact-mf">
                <div id="contact" className="box-shadow-full">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="title-box-2">
                        <h5 className="title-left">Send A Message</h5>
                      </div>
                      <div>
                        <form
                          onSubmit={this.onSubmit}
                          method="POST"
                          className="contactForm"
                        >
                          <div className="row">
                            <div className="col-md-12 mb-3">
                              <div className="form-group">
                                <input
                                  type="text"
                                  name="name"
                                  className="form-control"
                                  id="name"
                                  placeholder="Your Name"
                                  data-rule="minlen:4"
                                  data-msg="Please enter at least 4 chars"
                                  value={this.state.formData.name}
                                  onChange={this.onChange}
                                />
                                <div className="validation"></div>
                              </div>
                            </div>
                            <div className="col-md-12 mb-3">
                              <div className="form-group">
                                <input
                                  type="email"
                                  className="form-control"
                                  name="email"
                                  id="email"
                                  placeholder="Your Email"
                                  data-rule="email"
                                  data-msg="Please enter a valid email"
                                  value={this.state.formData.email}
                                  onChange={this.onChange}
                                />
                                <div className="validation"></div>
                              </div>
                            </div>
                            <div className="col-md-12 mb-3">
                              <div className="form-group">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="subject"
                                  id="subject"
                                  placeholder="Subject"
                                  data-rule="minlen:4"
                                  data-msg="Please enter at least 8 chars of subject"
                                  value={this.state.formData.subject}
                                  onChange={this.onChange}
                                />
                                <div className="validation"></div>
                              </div>
                            </div>
                            <div className="col-md-12 mb-3">
                              <div className="form-group">
                                <textarea
                                  className="form-control"
                                  name="message"
                                  rows="5"
                                  data-rule="required"
                                  data-msg="Please write something for us"
                                  placeholder="Message"
                                  value={this.state.formData.message}
                                  onChange={this.onChange}
                                ></textarea>
                                <div className="validation"></div>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <button
                                disabled={this.state.sending}
                                type="submit"
                                className={`button-big button-rouded ${!this.state.sending ? 'button button-a' : ''}`}
                              >
                                {!this.state.sending ? "Send Message" : "Sending..."}
                              </button>
                              {this.state.validation.show && this.state.validation.status === 'success' ? <div id="sendmessage show">Your message has been sent. Thank you!</div> : null}
                              {this.state.validation.show && this.state.validation.status === 'error' ? <div id="errormessage show">{this.state.validation.info}</div> : null}
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="title-box-2 pt-4 pt-md-0">
                        <h5 className="title-left">Get in Touch</h5>
                      </div>
                      <div className="more-info">
                        <p className="lead">
                          Whether you want to get in touch, talk about a project
                          collaboration, or just say hi, I'd love to hear from
                          you.
                          <br />
                          Simply fill the from and send me an email.
                        </p>
                        {/* <!-- <ul class="list-ico">
                                <li><span class="ion-ios-location"></span> 329 WASHINGTON ST BOSTON, MA 02108</li>
                                <li><span class="ion-ios-telephone"></span> (617) 557-0089</li>
                                <li><span class="ion-email"></span> contact@example.com</li>
                                </ul> --> */}
                      </div>
                      <div className="socials">
                        <ul>
                          <li>
                            <a
                              href="https://github.com/komangnopha"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <span className="ico-circle">
                                <i className="ion-social-github"></i>
                              </span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://www.linkedin.com/in/nova-artawan-83315715a/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <span className="ico-circle">
                                <i className="ion-social-linkedin"></i>
                              </span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="copyright-box">
                </div>
              </div>
            </div>
          </div>
        </footer>
      </section>
    );
  }
}

export default Contact;
